import { mdiArrowLeftThick } from '@mdi/js';
import { Card, Divider, Link, Stack, Typography } from '@mui/material';
import React, { Dispatch } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { fullSize } from '../../../Constants';
import { IAppReduxStore } from '../../../redux/store';
import BgImage from '../../General/BackgroundImage/BgImage';
import { logoutUser } from '../../../redux/user/sliceUserProfile';
import AppIcon from '../../General/Icons/AppIcon';

export default () => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'projectView' });

    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Access relevant state variables from the redux store. */
    const viewsError = useSelector((store: IAppReduxStore) => store.projectViews.error);
    const viewError = useSelector((store: IAppReduxStore) => store.projectViewData.structure.error);
    const userSettingsError = useSelector((store: IAppReduxStore) => store.userSettings.error);

    const message = viewsError?.message ?? viewError?.message;

    const userSettingsErrorLogOut = () => {
        if (userSettingsError) {
            dispatch(logoutUser());
        }
    };

    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                ...fullSize,
            }}
        >
            {userSettingsError && <BgImage imageFile={'background.jpg'} />}
            <Card sx={{ p: 2 }} elevation={3}>
                <Stack
                    direction='column'
                    spacing={2}
                    sx={{
                        alignSelf: 'center',
                    }}
                >
                    <Typography
                        variant='h4'
                        sx={{
                            color: 'error',
                        }}
                    >
                        {userSettingsError ? t('userSettingsLoadError') : t('projectLoadError')}
                    </Typography>

                    <Divider />

                    <Typography variant='body1'>
                        {userSettingsError ? t('redirectionText') : t(message)}
                    </Typography>

                    <Link
                        href='/'
                        onClick={userSettingsErrorLogOut}
                        sx={{
                            color: 'inherit',
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    >
                        <AppIcon
                            path={mdiArrowLeftThick}
                            color='rgba(0, 0, 0, 0.87)'
                            withLabel={true}
                            label={userSettingsError ? t('backToSignIn') : t('backToProjects')}
                            labelSx={{ ml: 1, fontWeight: 'bold' }}
                        />
                    </Link>
                </Stack>
            </Card>
        </Stack>
    );
};
